import merge from 'lodash/merge';
import React, { useContext, useEffect } from 'react';
import { ParameterValueEditor } from '../ParameterValueEditor';
import { ParameterDropdown } from '../ParameterDropdown';
import { findClientContextVariableDefault, parameterHasSpecificValues } from '../lib/Filters/parameterUtils';
import { ParameterItemContext } from './ParameterItemContext';
import { Key } from 'common/types/keyboard/key';

export const ParameterControlPopover = ({
  onUpdate,
  onClose
}: {
  onUpdate: (parameterOverrideValue: string) => void;
  onClose: () => void;
}) => {
  const { parameter, onParameterUpdate, clientContextVariables, editMode, textInputRef } =
    useContext(ParameterItemContext)!;

  useEffect(() => {
    const bodyEscapeHandler = (event: KeyboardEvent) => {
      if (event.key === Key.Escape) {
        onClose();
      }
    };

    document.body.addEventListener('keyup', bodyEscapeHandler);

    return () => {
      document.body.removeEventListener('keyup', bodyEscapeHandler);
    };
  }, []);

  // If in view mode, reset to the override in the published story. If in edit mode, reset to the
  // default in the parameter's client context variable.
  const onReset = () => {
    const resetValue = findClientContextVariableDefault(parameter.paramIds, clientContextVariables, editMode);
    const newParameter = merge({}, parameter, {
      overrideValue: resetValue
    });

    onParameterUpdate?.(newParameter);
    onClose();
  };

  // If the parameter or any of its linked parameters has specific values, then use a dropdown
  // list with those values, otherwise use a text box.
  if (parameterHasSpecificValues(parameter.paramIds, clientContextVariables)) {
    return <ParameterDropdown onReset={onReset} onUpdate={onUpdate} />;
  }

  return (
    <span ref={textInputRef}>
      <ParameterValueEditor onUpdate={onUpdate} onReset={onReset} />
    </span>
  );
};
